import { axiosInstance as request } from '@api/rest.service'

const api = '/to-dos/boards'

/**
 * @description GET /to-dos/boards?include=states
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_BOARDS_WITH_STATES = () => request.get(`${api}/?include=states`)

/**
 * @description GET /to-dos/boards
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_BOARDS = () => request.get(api)

/**
 * @description POST /to-dos/boards
 * @returns {AxiosPromise<any>}
 */
export const CREATE_TODOS_BOARD = payload => request.post(api, payload)

/**
 * @description PUT /to-dos/boards/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_TODO_BOARD = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /to-dos/boards/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_BOARD_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /to-dos/boards/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_TODOS_BOARD = id => request.delete(`${api}/${id}`)
